module.exports = __webpack_public_path__ + "static/media/image0002.4f524696.webp";